import { interpolateColor, useAnimatedStyle, useDerivedValue, withSpring } from 'react-native-reanimated';
import { useTheme } from 'styled-components/native';
import { springConfig } from '~/constants/animations';
import { AnimationsProps } from '~/types/animations';

export interface CheckboxAnimationsRenderPropValue {
    borderAnimatedStyles: {
        borderColor: string;
    };
    backgroundAnimatedStyles: {
        opacity: number;
    };
    checkIconAnimatedStyles: {
        opacity: number;
    };
}

export interface CheckboxAnimationsProps extends AnimationsProps<CheckboxAnimationsRenderPropValue> {
    checked: boolean;
}

export const CheckboxAnimations = ({ checked, children }: CheckboxAnimationsProps) => {
    const theme = useTheme();

    const checkedProgress = useDerivedValue(() => withSpring(Number(checked), springConfig.default));

    const borderAnimatedStyles = useAnimatedStyle(() => ({
        borderColor: interpolateColor(checkedProgress.value, [0, 1], [theme.border['40'], theme.border.interactive]),
    }));

    const backgroundAnimatedStyles = useAnimatedStyle(() => ({
        opacity: checkedProgress.value,
    }));

    const checkIconAnimatedStyles = useAnimatedStyle(() => ({
        opacity: checkedProgress.value,
    }));

    return children({ borderAnimatedStyles, backgroundAnimatedStyles, checkIconAnimatedStyles });
};
